<template>
  <div class="page-enter">
    <div class="page-head">
      <div><h2>豆包 AI 设置</h2><p>仅平台超级管理员可以修改全局额度；会员额度按账号独立累计，不自动清零。</p></div>
      <el-button icon="el-icon-refresh" :loading="loading || usageLoading" @click="load">刷新</el-button>
    </div>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon class="section-alert" />
    <el-card class="profile-page">
      <div slot="header"><strong>全局调用策略</strong></div>
      <el-form ref="form" :model="form" :rules="rules" label-position="top" :disabled="saving || loading">
        <el-form-item label="启用豆包 AI"><el-switch v-model="form.enabled" active-text="允许会员调用" inactive-text="关闭调用" /></el-form-item>
        <el-form-item label="每位会员累计 Token 上限" prop="token_limit"><el-input-number v-model="form.token_limit" :min="0" :max="9007199254740991" :step="10000" controls-position="right" /><p class="form-hint">输入、输出和推理 Token 均计入；设置为 0 会阻止所有会员调用。</p></el-form-item>
        <el-form-item label="模型 ID" prop="model"><el-input v-model.trim="form.model" maxlength="120" /></el-form-item>
        <div class="drawer-actions"><el-button type="primary" :loading="saving" :disabled="isDemo" @click="save">保存设置</el-button></div>
      </el-form>
    </el-card>
    <el-card>
      <div slot="header"><strong>会员用量</strong><span class="muted small" style="float:right">当前上限：{{ Number(form.token_limit).toLocaleString() }} Token</span></div>
      <el-table :data="usageRows" v-loading="usageLoading" empty-text="暂无会员用量">
        <el-table-column prop="username" label="会员账号" min-width="150" />
        <el-table-column prop="display_name" label="显示名" min-width="150" />
        <el-table-column label="累计 Token" min-width="150"><template slot-scope="s">{{ Number(s.row.total_tokens || 0).toLocaleString() }}</template></el-table-column>
        <el-table-column label="调用次数" width="100"><template slot-scope="s">{{ Number(s.row.call_count || 0).toLocaleString() }}</template></el-table-column>
        <el-table-column label="剩余额度" min-width="150"><template slot-scope="s">{{ Math.max(0, Number(form.token_limit || 0) - Number(s.row.total_tokens || 0)).toLocaleString() }}</template></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import api from '../../api';
import { errorMessage } from '../../utils/management.cjs';
const blank = () => ({ enabled: false, token_limit: 0, model: 'doubao-seed-2-1-pro-260915' });
export default {
  name: 'AiSettings',
  data: () => ({
    form: blank(), usageRows: [], loading: false, usageLoading: false, saving: false, error: '',
    rules: {
      token_limit: [{ required: true, message: '请输入额度', trigger: 'change' }, { validator: (rule, value, done) => (Number.isInteger(value) && value >= 0 ? done() : done(new Error('额度必须是大于等于0的整数'))) }],
      model: [{ required: true, message: '请输入模型 ID', trigger: 'blur' }, { pattern: /^[A-Za-z0-9][A-Za-z0-9._:-]{0,119}$/, message: '模型 ID 格式无效', trigger: 'blur' }]
    }
  }),
  computed: { isDemo() { return this.$store.getters.isDemo; } },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true; this.usageLoading = true; this.error = '';
      try {
        const settings = await api.aiSettings();
        this.form = { enabled: !!Number(settings.enabled), token_limit: Number(settings.token_limit || 0), model: settings.model || blank().model };
        this.usageRows = await api.aiUsage();
      } catch (error) { this.error = errorMessage(error, 'AI设置加载失败，请点击刷新重试'); }
      finally { this.loading = false; this.usageLoading = false; }
    },
    async save() {
      try {
        await this.$refs.form.validate();
        if (this.isDemo) return;
        this.saving = true; this.error = '';
        const saved = await api.updateAiSettings({ enabled: !!this.form.enabled, token_limit: Number(this.form.token_limit), model: this.form.model.trim() });
        this.form = { enabled: !!Number(saved.enabled), token_limit: Number(saved.token_limit), model: saved.model };
        this.$message.success('AI设置已保存');
      } catch (error) {
        if (error !== false) this.error = errorMessage(error, 'AI设置保存失败');
      } finally { this.saving = false; }
    }
  }
};
</script>

